import { toast } from 'react-toastify';

class NotificationService {
  public success(text: string){
    toast.success(text);
  }

  public error(text: string){
    toast.error(text);
  }
}

export const notificationService = new NotificationService();